import { useState } from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import * as Yup from 'yup';
import { useFormik } from "formik";
import { TextField } from "@/webkit/form/TextField";
import r from '@/kit/RoundButton/button.module.scss';
import { useRequestChangeEmail } from "@/query/queries/user/useRequestChangeEmail";
import s from './index.module.scss';

const getValidationSchema = t =>
  Yup.object().shape({
    email: Yup.string()
      .strictEmail(t('change_email_modal.email_invalid'))
      .max(50, t('change_email_modal.email_invalid'))
      .required(t('change_email_modal.email_required')),
  });

export const EnterEmailStep = ({ email, onSetEmail, onNext }) => {
  const [submittedEmail, setSubmittedEmail] = useState(email);
  const { mutateAsync: requestChangeEmail } = useRequestChangeEmail();
  const { t } = useTranslation('modal');

  const onSubmit = async ({ email }, formik) => {
    if (email === submittedEmail) {
      onNext();
      return;
    }
    const { success, error } = await requestChangeEmail({ new_email: email });
    formik.setSubmitting(false);

    if (success) {
      setSubmittedEmail(email);
      onSetEmail(email);
      onNext();
      return;
    }
    formik.setErrors({ email: error });
  };

  const { values, setFieldValue, errors, touched, isSubmitting, handleSubmit } =
    useFormik({
      validationSchema: getValidationSchema(t),
      onSubmit,
      initialValues: {
        email,
      },
    });

  return (
    <div className={s.modal}>
      <h1 className="f-hero-h5">
        {t('change_email_modal.change_email_address')}
      </h1>
      <div className={s.content}>
        <div>
          {t('change_email_modal.enter_new_email_instruction')}
        </div>
        <form className={s.form} onSubmit={handleSubmit}>
          <TextField
            name="email"
            label={t('change_email_modal.new_email')}
            value={values.email}
            placeholder={t('change_email_modal.enter_your_email')}
            onChange={v => setFieldValue('email', v.trim())}
            onClear={() => setFieldValue('email', '')}
            error={touched.email && errors.email}
          />
          <div className={s.footer}>
            <div />
            <button
              type="submit"
              className={classnames(s.button, r.black_large)}
              onSubmit={handleSubmit}
              disabled={
                !values.email
                || errors.email
                || isSubmitting
              }
            >
              {values.email === submittedEmail
                ? t('change_email_modal.continue')
                : t('change_email_modal.send_verification_code')
              }
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
